module.exports = __webpack_public_path__ + "static/metalangspecific-d6e1fb6ad5b3e8d60563ba1ff5eee3d4.png";